import { journeyConst, journeyLabels, requestTypes } from "../constants";

export function journeyItem(
  label,
  hidden,
  open,
  component,
  pxSellIdx = null,
  nextAction = null,
  mainSlotIdx = null,
  defaultSource = null
) {
  return {
    id: Math.random(),
    label,
    hidden,
    open,
    component,
    pxSellIdx,
    nextAction,
    // Which SEARCH PRODUCT source tab this slot should open on
    // ('listing' = Active Listings, 'catalog' = Database). Set when the slot
    // was created by a button that implies a source — "Add Listing" vs
    // "Source Product" are the same add_main action and differ only here.
    // null = fall back to the flow's own default.
    defaultSource,
    // mainSlotIdx > 0 marks SEARCH/CONFIRM_REQUEST entries for the
    // 2nd and 3rd MAIN order slots when the rep adds multiple
    // products to the same deal (request group). Slot 0 is the
    // legacy singular main; slots 1 and 2 read from the
    // additionalMain* state arrays.
    mainSlotIdx,
  };
}

export function newJourney() {
  return [
    journeyItem(
      journeyLabels.search,
      false,
      true,
      journeyConst.components.SEARCH
    ),
  ];
}

export function newOrderJourney(user) {
  const newJourney = [
    journeyItem(
      journeyLabels.searchCart,
      false,
      false,
      journeyConst.components.SEARCH
    ),
  ];

  if (user?.is_admin) {
    newJourney.push(
      journeyItem(
        journeyLabels.assignClient,
        false,
        true,
        journeyConst.components.ASSIGN_CLIENT
      )
    );
  } else {
    newJourney.push(
      journeyItem(
        journeyLabels.selectToSell,
        false,
        true,
        journeyConst.components.SEARCH,
        0
      )
    );
  }

  return newJourney;
}

export function newRequestJourney(user) {
  const newJourney = [
    journeyItem(
      journeyLabels.search,
      false,
      false,
      journeyConst.components.SEARCH
    ),
  ];

  if (user?.is_admin) {
    newJourney.push(
      journeyItem(
        journeyLabels.assignClient,
        false,
        false,
        journeyConst.components.ASSIGN_CLIENT
      )
    );
  }

  newJourney.push(
    journeyItem(
      journeyLabels.confirmRequest,
      true,
      false,
      journeyConst.components.SEND_QUOTE
    )
  );

  newJourney.push(
    journeyItem(
      journeyLabels.selectToSell,
      false,
      true,
      journeyConst.components.SEARCH,
      0
    )
  );

  return newJourney;
}

export function journeyForRequest(
  user,
  requestType,
  pxProducts = [],
  request = null
) {
  const newJourney = [
    journeyItem(
      requestType === requestTypes.PX_CART
        ? journeyLabels.searchCart
        : journeyLabels.search,
      false,
      false,
      journeyConst.components.SEARCH
    ),
  ];

  if (user?.is_admin) {
    newJourney.push(
      journeyItem(
        journeyLabels.assignClient,
        false,
        false,
        journeyConst.components.ASSIGN_CLIENT
      )
    );
  }

  if (pxProducts?.length > 0) {
    for (let i = 0; i < pxProducts.length; i++) {
      newJourney.push(
        journeyItem(
          journeyLabels.selectToSell,
          false,
          false,
          journeyConst.components.SEARCH,
          i
        )
      );
      newJourney.push(
        journeyItem(
          journeyLabels.confirmRequest,
          true,
          false,
          journeyConst.components.CONFIRM_REQUEST,
          i
        )
      );
    }

    newJourney.push(
      journeyItem(
        journeyLabels.summary,
        false,
        true,
        journeyConst.components.SUMMARY
      )
    );
  } else {
    newJourney.push(
      journeyItem(
        journeyLabels.confirmRequest,
        false,
        false,
        journeyConst.components.CONFIRM_REQUEST
      )
    );
    if (user?.is_admin) {
      if (!request?.xero_purchase_order_id && !request?.purchase_order_number) {
        newJourney.push(
          journeyItem(
            journeyLabels.sendQuote,
            false,
            true,
            journeyConst.components.SEND_QUOTE
          )
        );
      } else {
        newJourney.push(
          journeyItem(
            journeyLabels.sendQuote,
            false,
            false,
            journeyConst.components.SEND_QUOTE
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.verifySerial,
            false,
            false,
            journeyConst.components.VERIFY_SERIAL
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.consignmentAgreement,
            false,
            false,
            journeyConst.components.CONSIGNMENT_AGREEMENT
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.purchasingAgreement,
            false,
            false,
            journeyConst.components.PURCHASING_AGREEMENT
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.payments,
            false,
            false,
            journeyConst.components.PAYMENTS
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.purchaseOrder,
            false,
            false,
            journeyConst.components.PURCHASE_ORDER
          )
        );
        newJourney.push(
          journeyItem(
            journeyLabels.publishListing,
            false,
            true,
            journeyConst.components.PUBLISH_LISTING
          )
        );
      }
    }
  }

  return newJourney;
}
